export enum InvoiceValidationMessage {
    INVOICE_NOT_IN_STATE_UNAPPROVED = 'INVOICE_NOT_IN_STATE_UNAPPROVED',
    INVOICE_CURRENCY_NOT_SET = 'INVOICE_CURRENCY_NOT_SET',
    INVOICE_SUPPLIER_NOT_SET = 'INVOICE_SUPPLIER_NOT_SET',
    INVOICE_SUPPLIER_ADDRESS_NOT_SET = 'INVOICE_SUPPLIER_ADDRESS_NOT_SET',
    INVOICE_SUPPLIER_ADDRESS_MUST_HAVE_VAT = 'INVOICE_SUPPLIER_ADDRESS_MUST_HAVE_VAT',
    INVOICE_MUST_HAVE_ITEMS = 'INVOICE_MUST_HAVE_ITEMS',
    INVOICE_CURRENCY_NOT_MATCHING_CHARGE_CURRENCY = 'INVOICE_CURRENCY_NOT_MATCHING_CHARGE_CURRENCY',
    INVOICE_DEPARTMENT_NOT_SET = 'INVOICE_DEPARTMENT_NOT_SET',
    INVOICE_PAYMENT_DATE_NOT_SET = 'INVOICE_PAYMENT_DATE_NOT_SET',
    INVOICE_DATE_NOT_SET = 'INVOICE_DATE_NOT_SET',
    INVOICE_INVOICE_ADDRESS_NOT_SET = 'INVOICE_INVOICE_ADDRESS_NOT_SET',
    ALL_INVOICE_ITEMS_MUST_HAVE_NAME = 'ALL_INVOICE_ITEMS_MUST_HAVE_NAME',
    INVOICE_NUMBER_NOT_SET = 'INVOICE_NUMBER_NOT_SET',
    ALL_INVOICE_CHARGE_MUST_HAVE_NAME = 'ALL_INVOICE_CHARGE_MUST_HAVE_NAME',
    INVOICE_MISSING_MANDATORY_ATTACHMENT = 'INVOICE_MISSING_MANDATORY_ATTACHMENT',
    INVOICE_ACCOUNTING_COST_CENTER_NOT_SET = 'INVOICE_ACCOUNTING_COST_CENTER_NOT_SET',
    INVOICE_MATERIAL_GROUP_NOT_SET = 'INVOICE_MATERIAL_GROUP_NOT_SET',
}
